import React, { useState } from "react";
import { TranslationMemory, SegmentationItem } from "./types";
import { TranslationViewTranslationMemoryLookupsSource } from "./TranslationViewTranslationMemoryLookupsSource";
import { Button, Icon } from "../components/tailwind";
type Props = {
  focusedSegmentIndex: number;
  focusedSegment: SegmentationItem;
  sourceLanguage: string;
  targetLanguage: string;
  handleTranslationMemoryClick: (tm: TranslationMemory) => void;
};

export const TranslationViewTranslationMemoryLookups: React.FC<Props> = ({
  focusedSegmentIndex,
  focusedSegment,
  sourceLanguage,
  targetLanguage,
  handleTranslationMemoryClick,
}) => {
  const [lastFocusedSegmentIndex, setLastFocusedSegmentIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(true);
  const getSimilarityColor = (similarity: number): string => {
    if (similarity >= 0.9) {
      return "tw-bg-green-500";
    }
    if (similarity >= 0.5) {
      return "tw-bg-yellow-500";
    }
    return "tw-bg-red-500";
  };

  return (
    <>
      <h5
        className="tw-flex tw-gap-2 tw-items-center tw-mb-0"
        data-testid="translation-memory-lookups-header"
      >
        <Button
          icon
          size="sm"
          compact
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          data-balloon={isOpen ? "Hide" : "Expand"}
          data-balloon-pos="up-left"
        >
          <Icon
            name={isOpen ? "expand_more" : "navigate_next"}
            className="tw-leading-[1]"
          />
        </Button>
        Lookups{" "}
        {!isOpen && (
          <div className="tw-flex-1 tw-h-px tw-border-[1px] tw-border-gray-200" />
        )}
      </h5>
      {isOpen && (
        <>
          <TranslationViewTranslationMemoryLookupsSource
            focusedSegmentIndex={focusedSegmentIndex}
            focusedSegment={focusedSegment}
            sourceLanguage={sourceLanguage}
            targetLanguage={targetLanguage}
            handleTranslationMemoryClick={handleTranslationMemoryClick}
            lastFocusedSegmentIndex={lastFocusedSegmentIndex}
            setLastFocusedSegmentIndex={setLastFocusedSegmentIndex}
            getSimilarityColor={getSimilarityColor}
          />
          <span className="tw-text-gray-500 !tw-text-sm tw-mt-2">
            If a Lookup is wrong please contact us at{" "}
            <a
              href="mailto:translations@textual.se"
              className="tw-text-blue-500"
            >
              translations@textual.se
            </a>{" "}
            with the Lookup ID.
          </span>
        </>
      )}
    </>
  );
};
